import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { toArray } from 'rxjs';
import { AccessService } from 'app/access.service';
import { ApprovalCountService } from 'app/shared';
import { MenuMappingService } from 'app/menu-mapping.service';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  access: boolean;
  showBadge?: boolean;
  is_auditor_menu?: boolean;
}
export const ROUTES: RouteInfo[] = [
  // { path: '/branch', title: 'Branch', icon: 'route', class: '' },
  { path: '/statement', title: 'Statement', icon: 'dashboard', class: '',access:false },
  { path: '/group', title: 'Group', icon: 'person', class: '',access:false},
  { path: '/voucher', title: 'Voucher Master', icon: 'library_books', class: '',access:false },
  { path: '/ledger', title: 'Ledger', icon: 'account_balance_wallet', class: '' ,access:false},
  { path: '/voucher-posting', title: 'Posted Voucher', icon: 'receipt_long', class: '' ,access:false},
  { path: '/voucher-posting-create', title: ' Create Voucher', icon: 'receipt_long', class: '' ,access:false},
  { path: '/audit-report', title: ' Audit Report', icon: 'library_books', class: '' ,access:false},
  { path: '/day-book', title: 'Day Book', icon: 'today', class: '' ,access:false},
  { path: '/ledger-book', title: 'Ledger Book', icon: 'menu_book', class: '' ,access:false},
  { path: '/statement-view', title: 'Statement View', icon: 'library_books', class: '' ,access:false},
  { path: '/branch', title: 'Branch', icon: 'route', class: '' , access:false},
  { path: '/category-master', title: 'Category Master',  icon: 'category', class: '' , access:false},
  { path: '/category-item-mapping-master', title: 'Item Master', icon: 'library_books', class: '', access: false },
  // { path: '/item-master', title: 'Item Master',  icon: 'library_books', class: '' , access:false},
  // { path: '/unit-master', title: 'Unit Master',  icon: 'library_books', class: '' , access:false},
  { path: '/gst-master', title: 'GST Master',  icon: 'library_books', class: '' , access:false},
  { path: '/service-master', title: 'Service Master', icon:'library_books',class:'' , access:false},
  { path: '/create-invoice-payment-dialog', title: 'Payment Receive', icon:'payments',class:'' , access:false},
  // { path: '/invoice-details', title: 'Invoice Details', icon: 'library_books', class: '', access: false },
  { path: '/section-master', title: 'Section', icon: 'library_books', class: '', access: false },
  // { path: '/store-master', title: 'Store', icon: 'library_books', class: '', access: false },
  // { path: '/sku-master', title: 'Stock Keeping Unit', icon: 'library_books', class: '', access: false },
  {path: '/profit-cost-center', title: 'Profit/Cost Center', icon:'library_books', class: '', access: false },
  {path: '/bulk-voucher-posting', title: 'Bulk Voucher Posting', icon:'upload_file', class: '', access: false },
  {path:'/budget-master',title:'Budget Master', icon: 'library_books', class: '', access: false,is_auditor_menu:true },
  {path:'/budget-view',title:'Budget View', icon: 'library_books', class: '', access: false,is_auditor_menu:true },
  // {path:'/contact-person-master',title:'Contact Person Master', icon: 'library_books', class: '', access: false },
  {path:'/document',title:'Document',icon:'folder',class:'',access:false},
  {path:'/approval-path-master',title:'Approval Path Master',icon:'library_books',class:'',access:false},
  {path:'/queue-box',title:'Queue Box',icon:'notifications',class:'',access:false, showBadge: true},
  {path:'/budget-master',title:'Budget Type Master', icon: 'library_books', class: '', access: false ,is_auditor_menu:true},
  {path:'/budget-view',title:'Set Budget', icon: 'library_books', class: '', access: false,is_auditor_menu:true },
  // {path:'/contact-person-master',title:'Contact Person Master', icon: 'library_books', class: '', access: false }
  { path: '/profit_cost_category_master', title: 'Profit/Cost Category Master', icon: 'library_books', class: '', access: false,is_auditor_menu:true},
  { path: '/category_budget_master',  title: 'Set Category Budget ', icon: 'library_books', class: '', access: false,is_auditor_menu:true},
  { path: '/category_budget-view',  title: 'Category Budget View ', icon: 'library_books', class: '', access: false,is_auditor_menu:true},
  {path:'/budget-ledger-view',title:'Budget Ledger View', icon: 'library_books', class: '', access: false,is_auditor_menu:true },
  { path: '/company-unit-master', title: 'Company Unit Master', icon: 'library_books', class: '', access: false, is_auditor_menu: true },
  { path: '/company-service-master', title: 'Company Service Master', icon: 'library_books', class: '', access: false, is_auditor_menu: true },
  { path: '/company-item-master', title: 'Company Item Master', icon: 'library_books', class: '', access: false, is_auditor_menu: true },
  { path: '/fixed-assets-template', title: 'Fixed Assets Template', icon: 'library_books', class: '', access: false, is_auditor_menu: false },
  { path: '/company-act-category', title: 'Company Act Category', icon: 'policy', class: '', access: false, is_auditor_menu: false },
  { path: '/it-act-category', title: 'IT Act Category', icon: 'policy', class: '', access: false, is_auditor_menu: false },
  { path: '/depreciation-method', title: 'Depreciation Method', icon: 'library_books', class: '', access: false, is_auditor_menu: false },
  { path: '/fixed-assets-master', title: 'Fixed Assets Master', icon: 'library_books', class: '', access: false, is_auditor_menu: false },
  { path: '/ledger-type', title: 'Ledger Type', icon: 'library_books', class: '', access: false, is_auditor_menu: false },
  //{ path: '/ledger-path-setup', title: 'Ledger Path Setup', icon: 'library_books', class: '', access: false, is_auditor_menu: false },
  { path: '/all-employee-master-list', title: 'Employee Master List', icon: 'badge', class: '', access: false, is_auditor_menu: false },
  { path: '/sales-purchase-return', title: 'Sales Purchase Return', icon: 'library_books', class: '', access: false },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  menuItems: any[];
  branch_id: any;
  role_id: any;
  approvalCount: number = 0;
  access_list:any;
  is_auditor:boolean;
  user_id:any;
  userMenus: any[] = [];

  private subscription: any;
  @Input() isCollapsed: boolean = false;
  
  constructor(
    private accessService: AccessService,
    private approvalCountService: ApprovalCountService,
    private menuMappingService: MenuMappingService
  ) { 

    let userString = localStorage.getItem('data');
    let user = JSON.parse(userString) || {};
    this.branch_id = user?.branch_id;
    this.role_id = user?.role_id;
    this.user_id = user?.id;
     const accessListData = localStorage.getItem('accesslist');
    if (accessListData) {
      this.access_list = JSON.parse(accessListData);
      if(this.user_id!=1){
      this.is_auditor=this.access_list[0]?.['is_auditor'] ?? 0;
      }else{
        this.is_auditor=true;
      }
    }
  }

  ngOnInit() {
    // Load user menus and apply access control
    this.loadUserMenusAndApplyAccess();
    
    // Subscribe to approval count updates
    this.subscription = this.approvalCountService.getApprovalCount().subscribe(
      (count) => {
        this.approvalCount = count.total;
      }
    );
    
    // Initial load of approval count
    this.approvalCountService.refreshApprovalCount();
  }

  loadUserMenusAndApplyAccess() {
    // Check if user is superadmin (user_id = 1)
    if (this.user_id === 1) {
      // Superadmin has access to all menus
      this.menuItems = ROUTES.filter(menuItem => menuItem).map(route => {
        route.access = true;
        return route;
      });
      return;
    }

    // For regular users, fetch menu access
    this.accessService.getUserMenusFromConfig().subscribe(
      (menus) => {
        this.userMenus = menus;
        this.applyMenuAccess();
      },
      (error) => {
        console.error('Error fetching user menus:', error);
        // Fallback: show all menus if API fails
        this.menuItems = ROUTES.filter(menuItem => menuItem).map(route => {
          route.access = false;
          return route;
        });
      }
    );
  }

  applyMenuAccess() {
    this.menuItems = ROUTES.filter(menuItem => menuItem).map(route => {
      // Check if user has access to this menu
      const hasAccess = this.menuMappingService.hasMenuAccess(route.path, this.userMenus);
      
      // Apply auditor check for auditor-only menus
      if (hasAccess && route.is_auditor_menu && !this.is_auditor) {
        route.access = false;
      } else {
        route.access = hasAccess;
      }
      
      return route;
    });
  }
  
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };

  canAccessMenu(menuItem: any): boolean {
  // User must have access
  if (!menuItem.access) {
    return false;
  }

  // If it's an auditor-only menu, the user must be an auditor
  if (menuItem.is_auditor_menu && !this.is_auditor) {
    return false;
  }

  return true;
}
}
